module.exports = __webpack_public_path__ + "static/media/carte-madagascar.b8d8368e.svg";